import { render, staticRenderFns } from "./application.vue?vue&type=template&id=24b95dd8&scoped=true&"
import script from "./application.vue?vue&type=script&lang=js&"
export * from "./application.vue?vue&type=script&lang=js&"
import style0 from "./application.vue?vue&type=style&index=0&id=24b95dd8&prod&lang=sass&scoped=true&"
import style1 from "./application.vue?vue&type=style&index=1&id=24b95dd8&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b95dd8",
  null
  
)

export default component.exports